import React, { useEffect, useState } from 'react';
import FlashingDot from '../FlashingDot';
import Showcase from '../Showcase';
import bddImage from '../../images/medals/bdd.png';
import criticalThinkingImage from '../../images/medals/critical_thinking.png';
import dockerImage from '../../images/medals/docker.png';
import flexibilityImage from '../../images/medals/flexibility.png';
import gitImage from '../../images/medals/git.png';
import hadoopImage from '../../images/medals/hadoop.png';
import javaImage from '../../images/medals/java.png';
import jsImage from '../../images/medals/js.png';
import ocamlImage from '../../images/medals/ocaml.png';
import problemSolvingImage from '../../images/medals/problem_solving.png';
import pythonImage from '../../images/medals/python.png';
import teamworkImage from '../../images/medals/teamwork.png';

const SkillDisplay = ({ trackedObjects }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMedalModalOpen, setIsMedalModalOpen] = useState(false);
  const [selectedSlide, setSelectedSlide] = useState('0');

  const showMedalModal = (i) => {
    setSelectedSlide(i);
    setIsMedalModalOpen(true);
  };

  const displayStyle = {
    transitionProperty: 'opacity',
    opacity: isVisible ? 1 : 0,
    transition: "opacity 2s ease-in",  
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  const [teamwork, setTeamwork] = useState(null);
  const [criticalThinking, setCriticalThinking] = useState(null);
  const [problemSolving, setProblemSolving] = useState(null);
  const [flexibility, setFlexibility] = useState(null);
  const [javascript, setJavascript] = useState(null);
  const [databases, setDatabases] = useState(null);
  const [docker, setDocker] = useState(null);
  const [git, setGit] = useState(null);
  const [hadoop, setHadoop] = useState(null);
  const [java, setJava] = useState(null);
  const [ocaml, setOcaml] = useState(null);
  const [python, setPython] = useState(null);

  useEffect(() => {
    setTeamwork(trackedObjects.find(o => o.name.toLowerCase() === 'teamwork-stand'));
    setCriticalThinking(trackedObjects.find(o => o.name.toLowerCase() === 'critical-thinking-stand'));
    setProblemSolving(trackedObjects.find(o => o.name.toLowerCase() === 'problem-solving-stand'));
    setFlexibility(trackedObjects.find(o => o.name.toLowerCase() === 'flexibility-stand'));
    setJavascript(trackedObjects.find(o => o.name.toLowerCase() === 'javascript-medal'));
    setDatabases(trackedObjects.find(o => o.name.toLowerCase() === 'database-medal'));
    setDocker(trackedObjects.find(o => o.name.toLowerCase() === 'docker-medal'));
    setGit(trackedObjects.find(o => o.name.toLowerCase() === 'git-medal'));
    setHadoop(trackedObjects.find(o => o.name.toLowerCase() === 'hadoop-medal'));
    setJava(trackedObjects.find(o => o.name.toLowerCase() === 'java-medal'));
    setOcaml(trackedObjects.find(o => o.name.toLowerCase() === 'ocaml-medal'));
    setPython(trackedObjects.find(o => o.name.toLowerCase() === 'python-medal'));
  }, [trackedObjects]);

  /*
  {isMedalModalOpen && (<MedalModal setIsModalOpen={setIsMedalModalOpen} index={medalIndex} setIndex={setMedalIndex} />)}
    <TooltipButton width={150} showModal={showMedalModal} height={300} position={{ x: 310, y: 160 }} title={'Teamwork'} placement={'bottom'} index={0}/>
    <TooltipButton width={150} showModal={showMedalModal} height={300} position={{ x: 575, y: 160 }} title={'Critical thinking'} placement={'bottom'} index={1}/>
    <TooltipButton width={150} showModal={showMedalModal} height={200} position={{ x: 855, y: 260 }} title={'Problem solving'} placement={'bottom'} index={2}/>
    <TooltipButton width={150} showModal={showMedalModal} height={300} position={{ x: 1080, y: 160 }} title={'Flexibility'} placement={'bottom'} index={3}/>
    <TooltipButton width={60} showModal={showMedalModal} height={165} position={{ x: 430, y: 550 }} title={'JavaScript'} placement={'bottom'} index={4} />
    <TooltipButton width={60} showModal={showMedalModal} height={240} position={{ x: 505, y: 550 }} title={'Databases'} placement={'bottom'} index={5} />
    <TooltipButton width={60} showModal={showMedalModal} height={190} position={{ x: 590, y: 550 }} title={'Docker'} placement={'bottom'} index={6} />
    <TooltipButton width={60} showModal={showMedalModal} height={155} position={{ x: 660, y: 550 }} title={'Git'} placement={'bottom'} index={7} />
    <TooltipButton width={60} showModal={showMedalModal} height={170} position={{ x: 735, y: 550 }} title={'Hadoop'} placement={'bottom'} index={8} />
    <TooltipButton width={60} showModal={showMedalModal} height={180} position={{ x: 825, y: 550 }} title={'Java'} placement={'bottom'} index={9} />
    <TooltipButton width={60} showModal={showMedalModal} height={195} position={{ x: 907, y: 550 }} title={'OCaml'} placement={'bottom'} index={10} />
    <TooltipButton width={60} showModal={showMedalModal} height={240} position={{ x: 995, y: 550 }} title={'Python'} placement={'bottom'} index={11} />
  */

  return (
    <div style={displayStyle}>
    {isVisible && (
        <>
          <Showcase 
            selectedSlide={selectedSlide}
            setIsModalOpen={setIsMedalModalOpen}
            isModalOpen={isMedalModalOpen}
            images={[
              teamworkImage,
              criticalThinkingImage,
              problemSolvingImage,
              flexibilityImage,
              jsImage,
              bddImage,
              dockerImage,
              gitImage,
              hadoopImage,
              javaImage,
              ocamlImage,
              pythonImage,
            ]} 
            width={400}
          />
          {teamwork && <FlashingDot onClick={showMedalModal} param={0}  position={{ x: teamwork.pos.x, y: teamwork.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Teamwork'}} />}
          {criticalThinking && <FlashingDot onClick={showMedalModal} param={1}  position={{ x: criticalThinking.pos.x, y: criticalThinking.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Critical Thinking'}} />}
          {problemSolving && <FlashingDot onClick={showMedalModal} param={2}  position={{ x: problemSolving.pos.x, y: problemSolving.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Problem Solving'}} />}
          {flexibility && <FlashingDot onClick={showMedalModal} param={3}  position={{ x: flexibility.pos.x, y: flexibility.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Flexibility'}} />}
          {javascript && <FlashingDot onClick={showMedalModal} param={4}  position={{ x: javascript.pos.x, y: javascript.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'JavaScript'}} />}
          {databases && <FlashingDot onClick={showMedalModal} param={5}  position={{ x: databases.pos.x, y: databases.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Databases'}} />}
          {docker && <FlashingDot onClick={showMedalModal} param={6}  position={{ x: docker.pos.x, y: docker.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Docker'}} />}
          {git && <FlashingDot onClick={showMedalModal} param={7}  position={{ x: git.pos.x, y: git.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Git'}} />}
          {hadoop && <FlashingDot onClick={showMedalModal} param={8}  position={{ x: hadoop.pos.x, y: hadoop.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Hadoop'}} />}
          {java && <FlashingDot onClick={showMedalModal} param={9}  position={{ x: java.pos.x, y: java.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Java'}} />}
          {ocaml && <FlashingDot onClick={showMedalModal} param={10}  position={{ x: ocaml.pos.x, y: ocaml.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'OCaml'}} />}
          {python && <FlashingDot onClick={showMedalModal} param={11}  position={{ x: python.pos.x, y: python.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Python'}} />}
        </>
      )}
    </div>
  );
};

export default SkillDisplay;